import { TEAM_FULL_PAGE_SEARCH_PAGE, TEAM_FULL_PAGE_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const teamsAppGlobalSearchRoute = createGlobalRoute({
  layout: 'home',
  nav4Layout: 'expanded',
  exact: true,
  name: TEAM_FULL_PAGE_SEARCH_PAGE,
  path: TEAM_FULL_PAGE_SEARCH_PATH,
  query: ['text?'],
  subproduct: 'townsquare-people-team-directory',
});
